import {defineStyleConfig, type ThemingProps} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

import {tokens as darkTokens} from '../../generated/dark';
import {tokens} from '../../generated/light';

const {core} = tokens;
const {
  components: {tags},
} = tokens;
const {
  components: {tags: tagsDark},
} = darkTokens;

const getColorSchemeProperties = (props: ThemingProps) => {
  const map = {
    critical: {
      borderColor: `${mode(tags.critical[`stroke-default`], tagsDark.critical[`stroke-default`])(props)}`,
      [`--tag-bg`]: `colors.${mode(
        tags.critical[`background-default`],
        tagsDark.critical[`background-default`],
      )(props)}`,
      [`--tag-color`]: `colors.${mode(tags.critical[`text-default`], tagsDark.critical[`text-default`])(props)}`,
    },
    medium: {
      borderColor: `${mode(tags.medium[`stroke-default`], tagsDark.medium[`stroke-default`])(props)}`,
      [`--tag-bg`]: `colors.${mode(tags.medium[`background-default`], tagsDark.medium[`background-default`])(props)}`,
      [`--tag-color`]: `colors.${mode(tags.medium[`text-default`], tagsDark.medium[`text-default`])(props)}`,
    },
    high: {
      borderColor: `${mode(tags.high[`stroke-default`], tagsDark.high[`stroke-default`])(props)}`,
      [`--tag-bg`]: `colors.${mode(tags.high[`background-default`], tagsDark.high[`background-default`])(props)}`,
      [`--tag-color`]: mode(tags.high[`text-default`], tagsDark.high[`text-default`])(props),
    },
    low: {
      borderColor: mode(tags.low[`stroke-default`], tagsDark.low[`stroke-default`])(props),
      [`--tag-bg`]: `colors.${mode(tags.low[`background-default`], tagsDark.low[`background-default`])(props)}`,
      [`--tag-color`]: mode(tags.low[`text-default`], tagsDark.low[`text-default`])(props),
    },
    default: {
      borderColor: `${mode(tags.default.stroke, tagsDark.default.stroke)(props)}`,
      [`--tag-bg`]: `colors.${mode(tags.default[`background-default`], tagsDark.default[`background-default`])(props)}`,
      [`--tag-color`]: `colors.${mode(tags.default[`text-default`], tagsDark.default[`text-default`])(props)}`,
    },
  };

  return map[props.colorScheme as keyof typeof map] || map.default;
};

export const tagTheme = defineStyleConfig({
  baseStyle: props => ({
    display: `inline-flex`,
    alignItems: `center`,
    justifyContent: `center`,
    flexShrink: 0,
    borderWidth: `1px`,
    borderStyle: `solid`,
    ...getColorSchemeProperties(props),
  }),
  sizes: {
    xxs: {
      fontSize: `sm`,
      lineHeight: `sm`,
      paddingX: `space-050`,
      height: tags[`height-xxs`],
      gap: tags.xxs,
      py: 0,
      borderRadius: core.radii[`radius-050`],
    },
    sm: {
      height: tags[`height-sm`],
      padding: tags[`padding-sm`],
      gap: tags.xs,
      borderRadius: core.radii[`radius-100`],
    },
    md: {
      height: tags[`height-md`],
      padding: tags[`padding-md`],
      gap: tags.md,
      borderRadius: core.radii[`radius-150`],
    },
    lg: {
      height: tags[`height-lg`],
      padding: tags[`padding-lg`],
      gap: tags.lg,
      borderRadius: core.radii[`radius-200`],
    },
  },
  defaultProps: {
    size: `md`,
    colorScheme: `default`,
  },
});
